<template>
  <div class="index">
    <div class="index__logo-animated left logo-fade delay-two"></div>
    <div class="index__logo-animated bottom logo-fade"></div>
    <div class="index__logo-animated top logo-fade delay-one"></div>

    <div class="index__banner">
      <img
      class="image-logo"
      src="../../public/img/icons/hermes-icon.png"
      alt="Logo Hermes"
      />
      <div class="index__banner-container--text">
        <h1 class="index__banner--title with-bar">
          Bem-vindo ao
          <br />
          <strong>Hermes</strong>
          <div class="line-big" style="width: 150px;"></div>
        </h1>
        <p class="side-text">
          Para sincronizar o totem com sua instituição, efetue login ou escaneie o
          QR Code abaixo.
        </p>
        <button class="logout-btn" @click="logOut" v-if="isLoggedIn">
          <img src="../../public/img/icons/logout-icon.svg" alt="Logout" />
        </button>
        <div>
        </div>
      </div>
    </div>

    <div class="index__login-panel-bg">
      <div class="index__login-panel">
        <div class="index__login-logo" style="z-index: 0">
          <img
            src="../../public/img/icons/logo-opacity.svg"
            alt="Logo Hermes"
          />
        </div>

        <div class="options-container">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      keyboardStatus: false,
    };
  },
  components: {
  },
  methods: {
    handleVisitor() {
      this.$router.push("/visitors");
    },
    logOut() {
      this.$store.commit("setLogoffSessionTotem", '');
      this.$router.push({ name: "sync" });
    },
  },
  mounted() {
    this.$store.commit('setIsLoading', false)
},
computed: {
  isLoggedIn() {
    return this.$store.state.auth;
  }
},
watch: {
  'this.$store.state.showKeyboard'(newVal) {
    this.keyboardStatus = newVal;
  }
}
};
</script>

<style scoped>
.options-container {
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  /* align-items: center; */
  padding: 20px;
  height: 100%;
  width: 100%;
}

.index__login-panel{
  border-bottom: 0px !important;
}

.image-logo{
  margin-left: 3vw;

}

.index{
  position: relative !important;
  min-height: 100vh !important;
}

.index__banner{
  background-image: url('../../public/img/home-bg.png');
  height: 100% !important;
  width: 100% !important;
  position: absolute;
  display: flex;
  flex-direction: column;
  padding-left: 4vw;
  justify-content: center;
}

.index__banner--title{
  font-size: 40px;
  font-weight: 300 !important;
  color: #888791;
  margin-bottom: 10px;
}

.index__banner-container--text{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 50px;
  align-items: start;
  padding: 20px;
  height: 45%;
  width: 40%;
  /* background-color: red; */

  p{
    width: 22vw;
  }
}

.logout-btn{
  padding: 20px 20px;
  background-color: transparent;
  color: white;
  border: none;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 10px;
}

.logout-btn img{
  width: 15px;
  height: 15px
}

</style>
